import { Directive, computed, input } from '@angular/core';

export type DialogVariant = 'media' | 'panel';
export type DialogSize = 'sm' | 'md' | 'lg' | 'full';

@Directive({
  selector: 'dialog[grooveDialog]',
  standalone: true,
  host: {
    class: 'groove-dialog',
    '[attr.data-variant]': 'variantAttr()',
    '[attr.data-size]': 'sizeAttr()',
  },
})
export class GrooveDialogDirective {
  readonly variant = input<DialogVariant>('media');
  readonly size = input<DialogSize>('full');

  protected readonly variantAttr = computed(() =>
    this.variant() === 'media' ? null : this.variant(),
  );
  protected readonly sizeAttr = computed(() =>
    this.size() === 'full' ? null : this.size(),
  );
}
